import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PreenchFormularioDadosModel} from '../../../../../../../../../model/planilhas/preench-form.model';
import {
    CampoFormularioEstruturaModel,
    CampoFormularioModel
} from '../../../../../../../../../model/planilhas/campo-formulario.model';
import {GatilhoCondicional} from '../../../../../../../../../model/planilhas/GatilhoCondicional';
import {_ListEmittedModel} from '../../ui-checklist-group-fields.component';
import {
    FormItemType
} from '../../../../../../../../../shared-pages/planilhas/manage-forms/form-creator/utils/form-checklist.models';

@Component({
    selector: 'ui-checklist-list-field',
    standalone: false,
    templateUrl: './ui-checklist-list-field.html',
    styleUrl: './ui-checklist-list-field.scss'
})
export class UiChecklistListField implements OnInit {
    @Input() group: CampoFormularioModel;
    @Input() field: CampoFormularioEstruturaModel;
    @Input() data: PreenchFormularioDadosModel;
    @Input() triggers: GatilhoCondicional[];

    @Output() groupTriggerChange = new EventEmitter<_ListEmittedModel>();

    ngOnInit() {
        if (Array.isArray(this.data.valor)) {
            this.data.valor?.forEach((value) => {
                this.selectItem(value);
            });
        } else {
            this.selectItem(this.data.valor);
        }
    }

    validateConditional() {
        if (!this.field.cond_item) return;

        const aux = this.field.cond_item.split(',') as Array<String>;

        if (Array.isArray(this.data.valor)) {
            return aux?.some(cond => this.data.valor?.includes(cond));
        } else {
            return aux?.some(cond => this.data.valor === cond);
        }
    }

    selectItem(item: string) {
        if (this.field.tipo == FormItemType.LIST_FIXED) {
            if (this.data.valor === item) {
                this.data.valor = undefined;
                return;
            }

            this.data.valor = item;
        } else {
            this.data.valor = this.data.valor ?? [];

            if (item) {
                const idx = this.data.valor.indexOf(item);

                if (idx > -1) {
                    this.data.valor.splice(idx, 1);
                    return;
                } else {
                    this.data.valor.push(item);
                }
            }
        }

        if (this.hasConditional(item)) {
            this.showConditionalGroup(item);
        }
    }

    isInconsistency(value: string) {
        return this.field.valores_com_inconsistencia?.some(inc => inc === value);
    }

    hasConditional(item: string) {
        return !!this.getTrigger(item);
    }

    hasTriggeredConditional(item: string) {
        return this.hasConditional(item) && this.wasSelected(item);
    }

    showConditionalGroup(item: string) {
        const trigger = this.getTrigger(item);

        if (!trigger) return;

        this.groupTriggerChange.emit({
            trigger,
            field: this.field,
            data: this.data
        });
    }

    wasSelected(item: string) {
        if (Array.isArray(this.data.valor)) {
            return this.data.valor?.some((value) => value === item);
        }

        return this.data.valor === item;
    }

    getHighlightColor(wasSelected: boolean, isInconsistency: boolean, hasCondicional: boolean) {
        if (wasSelected) {
            if (hasCondicional) {
                return 'warning';
            }

            return isInconsistency ? 'danger' : 'secondary';
        }

        return 'warning';
    }

    private getTrigger(item: string) {
        return this.triggers.find(gat =>
            gat.gatilho_campo_formulario_id === this.group.id
            && gat.gatilho_regra.valor.toString().toUpperCase() === item.toUpperCase()
            && gat.gatilho_campo_ordem === this.field.id
        );
    }
}
